import React, { Component, Fragment } from 'react';
import {
	OverlayTrigger,
} from "react-bootstrap";
import FrontEndRoutes from "routes/FrontEndRoutes.jsx";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import { IoMdMenu } from 'react-icons/io';
import { FiChevronDown } from 'react-icons/fi';
import {Helmet} from 'react-helmet';

import { login, logout } from 'redux/actions/front-end-action';
import User from 'helper/User';
import Logo from 'components/FrontEnd/Brand/Logo';
import ThemeModal from 'components/ThemeComponents/ThemeModal';
import { Roles } from 'constants/Roles';
import SideNavDashboard from 'layouts/Frontend/Dashboard/SideNavDashboard';
import { adminUserActions } from 'redux/actions/admin-user-action';
import { s3StaticPath } from '../../../helper/helperFunctions';
// import MyImage from 'components/Upload/MyImage';

class HeaderPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      routes: '',
      showNav: false,
      email: '',
      password: '',
      submitted: false,
      showHelp: false,
      loginShow: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    if (Object.keys(this.props.match.params).length > 1) {
      const params = { ...this.props.match.params };
      if (params.username !== undefined && params.password !== undefined) {
        this.props.loginCall(params.username, params.password)
      }
    }
  };

  handleLoginShow = () => {
    console.log("2.1351351.")
    this.setState({
        loginShow: !this.state.loginShow
    })
  }
  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();
    document.querySelector('.loginIcon').classList.add('open');
    this.setState({ submitted: true });
    const { email, password } = this.state;
    if (email && password) {
      this.props.loginCall(email, password);
    }
  }

  sortByColumn(a, colIndex) {
    a.sort(sortFunction);
    function sortFunction(a, b) {
      if (a[colIndex] === b[colIndex]) {
        return 0;
      }
      else {
        return (a[colIndex] < b[colIndex]) ? -1 : 1;
      }
    }
    return a;
  }

  handleNav = () => {
    this.setState({ showNav: !this.state.showNav })
  }

  logout = (e) => {
    e.preventDefault();
    this.props.dispatch(logout());
  }

  clickLinkHandle = (link) => {
    // e.preventDefault()
    window.location = link;
  }

  render() {
    // const { ITK_URL  } = process.env;
    const AdditionalNavLinks = [
      {
        name: "How does it work?",
        path: "https://incentivetripkit.com/",
        showMenuTestimonial: true,
      },
      {
        name: "FAQ",
        path: "https://incentivetripkit.com/faq/",
        showMenuTestimonial: true,
      },
      {
        name: "Contact",
        path: "https://incentivetripkit.com/contact/",
        showMenuTestimonial: true,
      },
      {
        name: "Login",
        path: "https://itk.incentivetripkit.com",
        showMenuTestimonial: true,
      },
      // Add more if needed
    ];

    const injectGA = () => {
      if (typeof window == 'undefined') {
        return;
      }
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag('js', new Date());

      gtag('config', 'UA-685268-14');
    }
    const { email, password, submitted } = this.state
    return (
      <React.Fragment>
      <Helmet>
      <script async src="https://www.googletagmanager.com/gtag/js?id=UA-685268-14"></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', 'UA-685268-14');
        `}
      </script>
      </Helmet>
      <header id="main-header" test={this.props.history.location.pathname} className={`et-fixed-header` + this.props.history.location.pathname === '/Home' || this.props.history.location.pathname === '/' ? '' : 'no_slider'}>
        { /*<nav className={'navbar navbar-default' + (this.props.history.location.pathname === '/Home' || this.props.history.location.pathname === '/'?' pos_abs':'')} role="navigation" data-spy="affix" data-offset-top="300">*/}
        <nav className='navbar navbar-default'>
          <div className="container">

            <div className="navbar-header">
              {/* <button type="button" className="navbar-toggle" data-toggle="collapse" data-target=".navbar-ex1-collapse"> */}
              <button type="button" className="navbar-toggle" onClick={this.handleNav}>
                <span className="sr-only">Toggle navigation</span>
                <i className="fa fa-navicon" style={{color: '#e34e56'}}></i>
              </button>

              <a className="navbar-brand" href="https://incentivetripkit.com">
                {
                  (this.props.history.location.pathname !== '/Home' && this.props.history.location.pathname !== '/') &&
                  <div>
                    {/* <Logo className="default frontEndLogo" /> */}
                    <img src={s3StaticPath('itk/Logo-TripKit-H.png')} className="default frontEndLogo" alt="logo" />
                  </div>
                }

                {
                  (this.props.history.location.pathname === '/Home' || this.props.history.location.pathname === '/') &&
                  // <Logo className="default frontEndLogo" />
                  <img src={s3StaticPath('itk/Logo-TripKit-H.png')} className="default frontEndLogo" alt="logo" />
                }
              </a>
            </div>


            <div className="collapse navbar-collapse navbar-ex1-collapse">
              <ul className="nav navbar-nav navbar-right">
                {
              [...FrontEndRoutes, ...AdditionalNavLinks].map((prop, key) => {
                const shouldShowMenus = this.props.location.pathname.includes('/Customer_Testimonials');
                const isAuthenticated = User.isAuthenticated();
                console.log("isAuthenticated", isAuthenticated);
                
                
                if (!isAuthenticated && prop.showMenuTestimonial) {
                  // if (!isAuthenticated && prop.showMenuTestimonial ) {
                    return (<li key={key} className={prop.navClass || ""}>
                        <a
                          href={prop.path}
                          // onClick={(e) => this.clickLinkHandle(prop.path.replace(/(\/:[\w]*\??)+/, ''))}
                          className="override-text-transform"
                          data-scroll="main_slider"
                          >
                          {prop.name}
                        </a>
                      </li>);
                  // } else {
                  //   return (
                  //     ''
                  //   );
                  // }
                }
                if (prop.redirect || !prop.showMenu) return null;

                if (isAuthenticated && prop.name === 'Login') return null;
                if (prop.dontShowMenue) return null;
                if (!isAuthenticated && prop.path === '/dashboard') return null;
                if (isAuthenticated && prop.name === 'Sign Up') return null;

                if (prop.name === 'Logout') {
                  if (isAuthenticated && !User.hasRole(Object.values(Roles).filter(role => role !== 'admin'))) {
                    return (
                      <li key={key}>
                        <Link
                          onClick={(e) => {
                            e.preventDefault();
                            this.props.adminLogout();
                          }}
                          to={prop.path.replace(/(\/:[\w]*\??)+/, '')}
                          className="text_14"
                          data-scroll="main_slider"
                        >
                          {prop.name}
                        </Link>
                      </li>
                    );
                  }
                  return null;
                }

                if (prop.childNav) {
                  return (
                    <li key={key} className={prop.navClass || "dropdown"}>
                      <a
                        href="#/"
                        className="dropdown-toggle text_14"
                        data-toggle="dropdown"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {prop.name} <FiChevronDown style={{ verticalAlign: "middle" }} />
                      </a>
                      <ul className="dropdown-menu">
                        {prop.childNav.map((item, index) => (
                          <li key={index}>
                            <Link to={item.path.replace(/(\/:[\w]*\??)+/, '')} className="text_14">
                              {item.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </li>
                  );
                }

                if (prop.name === 'Login') return null;

                if (prop.navClass === 'contactIcon') {
                  return (
                    <li key={key} className={prop.navClass}>
                      <a
                        key={key + 'contact'}
                        onClick={() => this.clickLinkHandle(prop.path.replace(/(\/:[\w]*\??)+/, ''))}
                        href="https://incentivetripkit.com/contact/"
                      >
                        Contact Us <i className='fa fa-mobile' aria-hidden="true" style={{ fontSize: "28px", top: "2px" }}></i>
                      </a>
                    </li>
                  );
                }

                return (
                  <li key={key} className={prop.navClass || ""}>
                    <Link
                      to={prop.path}
                      onClick={() => this.clickLinkHandle(prop.path.replace(/(\/:[\w]*\??)+/, ''))}
                      className="text_14"
                      data-scroll="main_slider"
                    >
                      {prop.name}
                    </Link>
                  </li>
                );
              })
            }
                

                {
                  User.hasRole(Object.values(Roles)) &&
                  <li onClick={this.handleNav}>
                    <a href="#/" style={{ fontSize: "30px", cursor: 'pointer' }}><IoMdMenu /></a>
                  </li>
                }
                {
                  /* User.isAuthenticated() &&
                  <React.Fragment>
                    <li className="pull-right"><a onClick={this.logout} href='/logout' data-scroll="main_slider">Logout {User.hasRole([Roles.PHOTO_ADMIN, Roles.TRAVELER]) && 'Order #' + User.getProperty('order.order_number')}</a></li>
                    <li><Link to="/dashboard">Dashboard</Link></li>
                  </React.Fragment> */
                }
              </ul>
            </div>
          </div>
        </nav>
        <SideNavDashboard handleNav={this.handleNav} title="Login Help" showNav={this.state.showNav} />
        <ThemeModal show={this.state.showHelp} title="Help" hide={() => { this.setState({ showHelp: !this.state.showHelp }) }}>
          <div className="text_22">Travelers & Group Leaders</div>
          <p className="text_14">If you do not know your login, please look on your traveler app card or watch the DVD video. Your group's username & password appears at the beginning and end of the your video. If you have lost the app card and video, please <Link onClick={() => { this.setState({ showHelp: !this.state.showHelp }) }} to="/Contact_Us" className="linkColor">Contact Us</Link> to get your login.</p>

          <div className="text_22 mt-lg">Tour Operators</div>
          <p className="text_14">If you do not know your login, click this <Link onClick={() => { this.setState({ showHelp: !this.state.showHelp }) }} to="/forgot-password" className="linkColor">Forgot Password</Link> link or <Link onClick={() => { this.setState({ showHelp: !this.state.showHelp }) }} to="/Contact_Us" className="linkColor">Contact Us.</Link></p>
        </ThemeModal>
      </header>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loginCall: (email, password) => { dispatch(login(email, password)) },
    logoutCall: () => { dispatch(logout()) },
    adminLogout: () => { dispatch(logout()) }
  }
}

function mapStateToProps(state) {
  const { loading, User, loggedIn } = state.frontEndUserReducer;
  return {
    loading, User, loggedIn
  };
}
const Header = connect(mapStateToProps, mapDispatchToProps)(HeaderPage);
export default Header;
